export default __webpack_public_path__ + "static/846-fe947d50880fafd36e562e3fd058a264.gif";